
import React from "react";

export const Converter=(address)=>{
    {console.log(address);}
    return `${address.slice(0,9)}....${address.slice(address.length-10)}`
}